import React, { useState, useEffect } from "react";
import MachineWizardStepper from "../RobotsPageComponents/MachineWizardStepper";
import CloudMachineWizardStepper from "../RobotsPageComponents/CloudMachineWizardStepper"
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CircularProgress from "@mui/material/CircularProgress";
import Slider from "@mui/material/Slider";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useToken } from "../items/UseToken";
import { Box, Grid, Typography, Paper } from "@mui/material";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import MemoryIcon from "@mui/icons-material/Memory";

import { useUser } from '../../Hooks/UserContext';



const steps = [
    "Welcome",
    "Choose mode",
    "Configure",
    "Test Connection"
];

const options = [
    {
        key: "buy",
        title: "Cloud Worker",
        description: "Get a new cloud machine",
        icon: <CloudQueueIcon fontSize="large" />,
    },
    {
        key: "bring",
        title: "Self Hosted Worker",
        description: "Use your own machine",
        icon: <MemoryIcon fontSize="large" />,
    },
];

export default function MachineWizardContainer(props) {
    const { token } = useToken();
    const { user } = useUser();
    const [activeStep, setActiveStep] = useState(0);
    const [number, setNumber] = useState(null);
    const [vendor, setVendor] = useState("twilio");
    const [selectedOption, setSelectedOption] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null); // Error handling


    const modes = ["selfhosted", "cloud"];
    useEffect(() => {
        
    }, [token]);

    // Step: Fetch AI-generated face image

    // Fetch machines from API where agent_id is empty (null)

    const handleSelect = (key) => {
        setSelectedOption(key);
    };

    const handleRegister = () => {
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({
                number: number,
                vendor: vendor,
                registered_by: user.username,
                agent_id: "UNASSIGNED"
            }),
        };

        fetch('api/createtelephony', requestOptions)
            .then((response) => {
                if (!response.ok) {
                    // If response is not ok, throw an error to trigger catch block
                    throw new Error(`Failed to create telephone: ${response.status} ${response.statusText}`);
                }
                return response.text(); // Parse the response (optional)
            })
            .then((data) => {
                setLoading(false);
                setActiveStep((prevStep) => prevStep + 1)
            })
            .catch((error) => {
                console.error("Error creating telephone:", error);
                alert("Failed to create. Please try again."); // User feedback
            });
    };
    const handleDone = () => {


        props.handleDialogClose()
    }
    

    const handleNext = () => {
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevStep) => prevStep - 1);
    };

    return (
        <>
            {!selectedOption && < Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 2,
                }}
            >
                <Typography variant="h5" sx={{ marginBottom: 3 }}>
                    Select Your Option
                </Typography>
                <Grid container spacing={4} justifyContent="center" sx={{ maxWidth: 900 }}>
                    {options.map((option) => (
                        <Grid item key={option.key}>
                            <Paper className="card-shine"
                                onClick={() => handleSelect(option.key)}
                                elevation={0}
                                sx={{
                                    width: 280,
                                    height: 200,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    textAlign: "center",
                                    borderRadius: 4,
                                    cursor: "pointer",
                                    backgroundColor: selectedOption === option.key ? "#f9fafb" : "#ffffff",
                                    border: selectedOption === option.key
                                        ? "2px solid #6366f1"
                                        : "1px solid #e5e7eb",
                                    boxShadow: selectedOption === option.key
                                        ? "0 4px 16px rgba(99,102,241,0.15)"
                                        : "0 4px 14px rgba(0,0,0,0.04)",
                                    transition: "all 0.25s ease",
                                    transform: selectedOption === option.key ? "translateY(-3px)" : "none",
                                    "&:hover": {
                                        border: "2px solid #7F56D9",
                                        boxShadow: "0 6px 18px rgba(99,102,241,0.2)",
                                        transform: "translateY(-4px)",
                                        backgroundColor: "#fafafa",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 72,
                                        height: 72,
                                        borderRadius: "20%",
                                        backgroundColor: "#f4f4f5",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mb: 2,
                                        transition: "background-color 0.3s",
                                        "& svg": {
                                            fontSize: 38,
                                            color: selectedOption === option.key ? "#6366f1" : "#64748b",
                                        },
                                    }}
                                >
                                    {option.icon}
                                </Box>

                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 600,
                                        letterSpacing: 0.4,
                                        mb: 0.8,
                                        color: selectedOption === option.key ? "#111827" : "#1f2937",
                                    }}
                                >
                                    {option.title}
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        opacity: 0.8,
                                        maxWidth: 200,
                                        color: "#4b5563",
                                        fontSize: "0.9rem",
                                        lineHeight: 1.4,
                                    }}
                                >
                                    {option.description}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

            </Box>
            }
            {
                selectedOption === "bring" && <MachineWizardStepper handleDialogClose={props.handleDialogClose}></MachineWizardStepper>
            }

            {
                selectedOption === "buy" && <CloudMachineWizardStepper handleDialogClose={props.handleDialogClose}></CloudMachineWizardStepper>
            }

        </>
        
    );
}
